<!-- src/views/LoginView.vue -->
<template>
    <div class="bg-white flex items-stretch min-h-screen">
      <div class="flex w-full">
        <!-- Left Side Visual -->
        <div class="flex-1 flex items-center justify-center bg-gray-100 background-image-div1">
        </div>
        <!-- Right Side Login Form -->
        <div class="flex-1 flex items-center justify-center">
          <div class="w-full max-w-md p-8">
            <div class="text-center mb-8">
              <img src="../assets/images/favicon.png" alt="Competify logo" class="mx-auto mb-4 w-20">
              <h1 class="text-2xl font-semibold text-gray-700">Sign In</h1>
            </div>
            <form @submit.prevent="loginWithEmail">
              <div class="mb-4">
                <label for="email" class="block text-sm font-medium text-gray-700">Sign In with E-Mail</label>
                <input
                  type="email"
                  id="email"
                  v-model="email"
                  required
                  class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  placeholder="Email"
                />
              </div>
              <div class="mb-6">
                <input
                  type="password"
                  id="password"
                  v-model="password"
                  required
                  class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  placeholder="Password"
                />
              </div>
              <div class="mb-6">
                <button
                  type="submit"
                  class="w-full flex items-center justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-gradient-to-r from-purple-600 to-pink-500 text-sm font-medium text-white hover:from-purple-700 hover:to-pink-600"
                >
                  Log In
                </button>
              </div>
              <div class="flex items-center justify-between mb-6">
                <hr class="flex-1 border-gray-300" />
                <span class="px-2 text-sm text-gray-500">Or</span>
                <hr class="flex-1 border-gray-300" />
              </div>
              <div class="mb-6">
                <button
                  type="button"
                  @click="loginWithGoogle"
                  class="w-full flex items-center justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"
                >
                  <!--<img src="https://placehold.co/20x20" alt="Google logo" class="mr-2" /> --> Sign In with Google
                </button>
              </div>
              <div class="mb-6">
                <button
                  type="button"
                  @click="loginWithLinkedIn"
                  class="w-full flex items-center justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-blue-700 text-sm font-medium text-white hover:bg-blue-800"
                >
                  <!--<img src="https://placehold.co/20x20" alt="LinkedIn logo" class="mr-2" /> --> Sign In with LinkedIn
                </button>
              </div>
              <div class="text-center text-sm">
                <span class="text-gray-500">Don't have an account?</span>
                <router-link to="/register" class="text-blue-500 hover:underline"> Register here</router-link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { ref, onMounted } from 'vue';
  import { useAuthStore } from '../stores/useAuthStore';
  import { useRouter } from 'vue-router';
  import { supabase } from '../supabase';
  
  export default {
    setup() {
      const authStore = useAuthStore();
      const email = ref('');
      const password = ref('');
      const router = useRouter();
  
      const loginWithEmail = async () => {
        try {
          await authStore.signInWithEmail(email.value, password.value);
          router.push('/feed');
        } catch (error) {
          alert(error.message);
        }
      };
  
      const loginWithGoogle = async () => {
        try {
          await authStore.signInWithGoogle();
        } catch (error) {
          alert(error.message);
        }
      };
  
      const loginWithLinkedIn = async () => {
        try {
          await authStore.signInWithLinkedIn();
        } catch (error) {
          alert(error.message);
        }
      };
  
      onMounted(async () => {
        const hash = window.location.hash;
        if (hash.includes('access_token')) {
          try {
            await supabase.auth.getSessionFromUrl({ storeSession: true });
            await authStore.fetchUser();
            router.push('/feed');
          } catch (error) {
            console.error('Error handling OAuth redirect:', error);
            alert('Authentication error. Please try logging in again.');
          }
        }
      });
  
      return {
        email,
        password,
        loginWithEmail,
        loginWithGoogle,
        loginWithLinkedIn,
      };
    },
  };
  </script>
  
  <style>
  .background-image-div1 {
    background-image: url('../assets/images/3.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 10px;
    margin: 30px;
  }
  </style>
  